import React from 'react'
import * as Sentry from '@sentry/react'
import { Switch, BrowserRouter } from 'react-router-dom'
import { AsyncConfiguration, AuthorizedConfiguration, SentryConfiguration } from '@/configuration'
import WatchRouter from '@/components/WatchRouter'
import Router from '@/routers'
import { PageLoading } from '@/components/Loading'
import GlobalError from '@/components/GlobalError'
import SourceLoadError from '@/components/SourceLoadError'
import './App.less'

window.onstorage = (e) => {
  if (e.key === 'loginSuccess') {
    window.location.reload()
  }
}

const App: React.FC = () => {
  return (
    <SentryConfiguration>
      <BrowserRouter>
        <AsyncConfiguration>
          <AuthorizedConfiguration>
            <GlobalError />
            <SourceLoadError />
            <WatchRouter />
            <Switch>
              <React.Suspense fallback={<PageLoading></PageLoading>}>
                <Router />
              </React.Suspense>
            </Switch>
          </AuthorizedConfiguration>
        </AsyncConfiguration>
      </BrowserRouter>
    </SentryConfiguration>
  )
}

App.displayName = 'App'
export default Sentry.withProfiler(App)
